import axios from 'axios';
import { GetSimilarImageParamType, GetSimilarImageResponseType } from './type';
import config from '../config-api.json';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

export async function apiGetSimilarImage(info: GetSimilarImageParamType) {
  const formData = new FormData();
  formData.append('num', '15');
  formData.append('session', 'nerdfactory-aivory');
  formData.append('image', info.image);
  const response = await axios.post<GetSimilarImageResponseType>(
    `${apiInfo.api_url_si_image}/api/upload_and_unified`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 20000 }
  );

  return response.data;
}

export { apiGetSimilarImage as default };
